import styled from 'styled-components';
import { ReactComponent as CloseIcon } from "assets/close-small.svg";

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s;

  @keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
`

export const ModalContainer = styled.div`
  position: relative;
  padding-top: 2.5rem;
  background: var(--black-300);
  width: 30rem;
  max-height: 30rem;
  overflow-y: scroll;
  animation: fadeIn 0.8s;

  h1 {
    font-size: 1.4rem;
    padding: 4rem;
    text-align: center;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
`